import { useQuery } from "@tanstack/react-query";
import { getActiveRoomTypes, getRoomTypeBySlug } from "@/lib/api/rooms";

export function usePublicRooms() {
  return useQuery({
    queryKey: ["publicRoomTypes"],
    queryFn: getActiveRoomTypes,
    staleTime: 5 * 60 * 1000, // 5 min — public data changes infrequently
  });
}

export function usePublicRoom(slug: string) {
  return useQuery({
    queryKey: ["publicRoomType", slug],
    queryFn: () => getRoomTypeBySlug(slug),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
  });
}